import { createAPI, createAPI2Res } from '../axios'

// 监控管理 API
const module = {
    tool: {
        cosSign: config => createAPI(`/admin/tool/cos`, 'post', config),
        apkList: config => createAPI("/admin/tool/apk-list", 'post', config),
    },
    product: {
        list: config => createAPI("/admin/product/list", 'post', config),
        save: config => createAPI("/admin/product/save", 'post', config),
        delete: config => createAPI("/admin/product/delete", 'post', config),
    },
    company: {
        list: config => createAPI("/admin/company/list", 'post', config),
        save: config => createAPI("/admin/company/save", 'post', config),
        delete: config => createAPI("/admin/company/delete", 'post', config),
    },
    subject: {
        list: config => createAPI("/admin/subject/list", 'post', config),
        save: config => createAPI("/admin/subject/save", 'post', config),
        delete: config => createAPI("/admin/subject/delete", 'post', config),
    },
    contract: {
        list: config => createAPI("/admin/contract/list", 'post', config),
        save: config => createAPI("/admin/contract/save", 'post', config),
        delete: config => createAPI("/admin/contract/delete", 'post', config),
        renew: config => createAPI("/admin/contract/renew", 'post', config),
        renewList: config => createAPI("/admin/contract/renew-list", 'post', config),
    },
    settlement: {
        list: config => createAPI("/admin/settlement/list", 'post', config),
        save: config => createAPI("/admin/settlement/save", 'post', config),
        delete: config => createAPI("/admin/settlement/delete", 'post', config),
    },
    prepay: {
        list: config => createAPI("/admin/prepay/list", 'post', config),
        save: config => createAPI("/admin/prepay/save", 'post', config),
        delete: config => createAPI("/admin/prepay/delete", 'post', config),
    },
    channel: {
        list: config => createAPI("/admin/channel/list", 'post', config),
        save: config => createAPI("/admin/channel/save", 'post', config),
        update: config => createAPI("/admin/channel/update", 'post', config),
        settlementList: config => createAPI("/admin/channel/settlement-list", 'post', config),
        timeList: config => createAPI("/admin/channel/time-list", 'post', config),
        options: config => createAPI("/admin/channel/options", 'post', config),
        getInfo: config => createAPI("/admin/channel/get-info", 'post', config),
    },
    operation: {
        refresh: config => createAPI("/admin/operation/refresh", 'post', config),
        detail: config => createAPI("/admin/operation/detail", 'post', config),
    },
    cost: {
        refresh: config => createAPI("/admin/cost/refresh", 'post', config),
        detail: config => createAPI("/admin/cost/detail", 'post', config),
        amount: config => createAPI("/admin/cost/amount", 'post', config),
        subject: config => createAPI("/admin/cost/subject", 'post', config),
        settlement: config => createAPI("/admin/cost/settlement", 'post', config),
        push: config => createAPI("/admin/cost/push", 'post', config),
        save: config => createAPI("/admin/cost/save", 'post', config),
    },
    dailyCost: {
        list: config => createAPI("/admin/dailyCost/list", 'post', config),
        pushToFinance: config => createAPI("/admin/dailyCost/one-merchant-push", 'post', config),
        pushAllChannels: config => createAPI("/admin/dailyCost/all-merchant-push", 'post', config),
      }
};

export default module;



// WEBPACK FOOTER //
// ./src/api/modules/module.js